import {bundle, Inject, Injectable} from "ng-metadata/core";
import {ActiveFacetsTransformationsModule} from "./activeFacetsTransformations/activeFacetsTransformations.module";
import {FacetsTransformer} from "./facetTransformation.module";

@Injectable()
export class ActiveFacetsTransformationService{
    private activeFacetListTransformers: [FacetsTransformer] | undefined[] = [] ;
    constructor(@Inject('$injector') private injector: ng.auto.IInjectorService){
        let module= bundle(ActiveFacetsTransformationsModule);
        // @ts-ignore
        for (let service of module._invokeQueue){ //load all transformer services
            // @ts-ignore
            this.activeFacetListTransformers.push(injector.get(service[2][0]));
        }
    }

    public transformActiveFacets(activeFacets){
        for (let facetTransformer of this.activeFacetListTransformers){
            activeFacets = facetTransformer.transform(activeFacets);
        }
        return activeFacets;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facetsTransformation/activeFacetsTransformation.service.ts